module.exports = __webpack_public_path__ + "static/media/illust01.608df4fc.png";